const scrollToAnchor = {
  data() {
    return {
      recursiveHashLimit: 50,
      postMessageHash: '',
    }
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.initHashAnchor()
      }, 1000)

      window.addEventListener('message', this.getPostMessageHash, false)

      window.parent.postMessage({ message: 'Ready and waiting' }, '*')
    })
  },
  beforeDestroy() {
    window.removeEventListener('message', this.getPostMessageHash)
  },
  methods: {
    getPostMessageHash(event) {
      if (!event.origin.includes('www.wellcertified.com')) {
        return
      }
      this.postMessageHash = event.data?.hash
      // if (event.data.hash) {
      //   const elemDiv = document.createElement('div')
      //   elemDiv.innerHTML = JSON.stringify(event.data.hash)
      //   document.body.prepend(elemDiv)
      // }
    },
    initHashAnchor() {
      // let hash = null

      // // if loaded in iframe
      // window.location !== window.parent.location
      //   ? (hash = window.parent.location?.hash)
      //   : (hash = window.location?.hash)

      // console.log(window.parent.location.href.split('#')[1])

      if (this.postMessageHash) {
        const scrollTarget = this.getScrollTarget(`${this.postMessageHash}`)

        this.$gsap.to(window, {
          duration: 1,
          scrollTo: {
            y: scrollTarget,
            offsetY: 70,
          },
        })
      }
    },
    getScrollTarget(hash, attempt = 0) {
      const scrollTarget = document.querySelector(`${hash}`)
      if (scrollTarget) {
        return scrollTarget
      }

      if (attempt === this.recursiveHashLimit) {
        return scrollTarget
      }

      if (!scrollTarget) {
        this.getScrollTarget(hash, attempt + 1)
      }
    },
  },
}

export { scrollToAnchor }
